import React, { useContext, useEffect } from "react";
import { Redirect } from "react-router";

import { AccountContext } from "../../../provider";
import View from "./view";

export default () => {
  const [userInfo] = useContext(AccountContext);
  const { isLoggedIn } = userInfo;

  useEffect(() => {}, []);

  if (isLoggedIn) {
    return <Redirect push to={`/`} />;
  }

  return <View />;
};
